import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// tslint:disable-next-line: max-line-length
import {
  NgbCollapseModule,
  NgbDatepickerModule,
  NgbTimepickerModule,
  NgbDropdownModule,
  NgbTooltipModule,
  NgbCarouselModule,
} from '@ng-bootstrap/ng-bootstrap';

import { SlimscrollDirective } from './slimscroll.directive';

import { PreloaderComponent } from './preloader/preloader.component';
import { PagetitleComponent } from './pagetitle/pagetitle.component';
import { FeatherIconDirective } from './feather-icon.directive';
import { ErrorsComponent } from './errors/errors.component';
import { ProjectTypeComponent } from './projectType/projectType.component';
import { ModalComponent } from './modal/modal.component';
import { RouterModule } from '@angular/router';
import { ImagesSliderComponent } from './images-slider/images-slider.component';
import { FieldTypeComponent } from './field-type/field-type.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ExpressionEditorComponent } from './editors/expression-editor/expression-editor.component';
import { MultiselectEditorComponent } from './editors/multiselect-editor/multiselect-editor.component';
import { SwitchEditorComponent } from './editors/switch-editor/switch-editor.component';
import { FieldsFilterPipe } from './editors/expression-editor/fields-filter.pipe';
import { DropdownEditorComponent } from './editors/dropdown-editor/dropdown-editor.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { ElementsModule } from './elements/elements.module';
import { ProjectTypeAvatarComponent } from './project-type-avatar/project-type-avatar.component';
import { NgbModule } from './ngb/ngb.module';

@NgModule({
  declarations: [
    SlimscrollDirective,
    PreloaderComponent,
    PagetitleComponent,
    FeatherIconDirective,
    ErrorsComponent,
    ProjectTypeComponent,
    ModalComponent,
    FieldsFilterPipe,
    ImagesSliderComponent,
    FieldTypeComponent,
    SwitchEditorComponent,
    ExpressionEditorComponent,
    MultiselectEditorComponent,
    DropdownEditorComponent,
    ProjectTypeAvatarComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    FontAwesomeModule,
    NgSelectModule,
    ElementsModule,
    NgbModule
  ],
  exports: [
    SlimscrollDirective,
    FeatherIconDirective,
    PreloaderComponent,
    PagetitleComponent,
    ErrorsComponent,
    ProjectTypeComponent,
    ModalComponent,
    ImagesSliderComponent,
    FieldTypeComponent,
    SwitchEditorComponent,
    ExpressionEditorComponent,
    MultiselectEditorComponent,
    DropdownEditorComponent,
    ElementsModule,
    FontAwesomeModule,
    ProjectTypeAvatarComponent,
    NgbModule
  ],
})
export class UIModule {}
